@if (show) {
  <div class="error-msg text-center">
    <p class="validate-error">
      <ng-content></ng-content>
    </p>
  </div>
}